import { makeStyles } from '@material-ui/core/styles';

const modalItemHeight = 60;
const modalTitleLines = 1;
const modalDescriptionLines = 2;

export const useStyle = makeStyles((theme) => ({
  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${theme.spacing(2.5)}px 0`,
    borderRadius: 0,
    boxShadow: 'none',
    margin: 0,
    backgroundColor: 'transparent',
    borderBottom: `1px solid ${theme.palette.divider}`,
    flexWrap: 'wrap',
    '&:first-child': {
      paddingTop: 0
    }
  },

  cardMedia: {
    position: 'relative',
    width: modalItemHeight,
    height: modalItemHeight,
    minWidth: modalItemHeight,
    minHeight: modalItemHeight,
    backgroundSize: 'contain',
    padding: 0
  },

  cardContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
    flexGrow: 1,
    padding: `0 ${theme.spacing(2)}px`,
    height: modalItemHeight,
    maxWidth: `calc(100% - ${60}px - 20px)`
  },

  textContent: {
    maxWidth: 'calc(100% - 60px)'
  },
  mixedTextContent: {
    maxWidth: '100%'
  },

  headerTitle: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
    display: '-webkit-box',
    height: `calc(${theme.typography.body2.fontSize} * ${theme.typography.body2.lineHeight} * ${modalTitleLines} - 1px)`,
    WebkitLineClamp: modalTitleLines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    OTextOverflow: 'ellipsis',
    textOverflow: 'ellipsis'
  },

  headerDesciption: {
    position: 'relative',
    // color: theme.palette.primary.contrastText,
    fontSize: theme.typography.caption.fontSize,
    lineHeight: 1.2,
    display: '-webkit-box',
    maxHeight: `calc(${theme.typography.caption.fontSize} * 1.2 * ${modalDescriptionLines} - 1px)`,
    WebkitLineClamp: modalDescriptionLines,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    OTextOverflow: 'ellipsis',
    textOverflow: 'ellipsis',

    '& strong': {
      fontWeight: theme.typography.fontWeightBold
    }
  },
  priceContent: {
    paddingLeft: theme.spacing(1),
    textAlign: 'right'
  },

  priceText: {
    fontWeight: theme.typography.fontWeightBold
  },

  mixedPriceText: {
    textAlign: 'right'
  },

  sale: {
    lineHeight: theme.typography.body2.lineHeight
  },
  bold: {
    fontWeight: theme.typography.fontWeightBold
  },
  lineThrough: {
    textDecoration: 'line-through'
  },

  cardActions: {
    // flexWrap: 'wrap',
    border: 'none',
    padding: 0,
    height: modalItemHeight,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(0.5)
  },
  clearIcon: {
    fontSize: theme.typography.h6.fontSize,
    cursor: 'pointer',
    zIndex: 5
  },
  clearIconDisable: {
    fontSize: theme.typography.h6.fontSize,
    cursor: 'unset',
    zIndex: 5,
    opacity: 0.3
  },

  points: {
    width: '100%',
    marginTop: theme.spacing()
  },

  pointsChip: {
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing()
  },

  pointsValue: {
    color: theme.palette.secondary.contrastText,
    fontWeight: theme.typography.fontWeightBold
  },

  ...theme.mixins.goodsListItemModal
}));
